<template>
    <span>
      <b-card no-body>
        <b-card-header>
            <b-row>
              <b-col md="10">
                <h3 tabindex="0">Visualizar Credenciados</h3>
              </b-col>
            </b-row>
        </b-card-header>
        <b-card-body>
          <b-row>
            <b-col sm="12">
              <b-form-group label="Nome, CPF, etc...:">
                  <b-form-input type="text" id="name" v-model="filtros.filter" placeholder="Nome, CPF, etc..."></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
              <!--<b-col sm="4">
                <b-form-group label="Perfil:">
                  <b-form-select v-model="filtros.participacao" class="mb-3">
                      <option selected :value="null"> Selecione </option>
                      <option v-for="(participacao, index) in participacoes" :key="index"> {{ participacao }} </option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col sm="2">
                <b-form-group label="UF:">
                  <b-form-select v-model="filtros.uf" class="mb-3">
                      <option selected :value="null"> Selecione </option>
                      <option v-for="estado in estados" :value="estado.id" :key="estado.id"> {{ estado.sigla }} </option>
                  </b-form-select>
                </b-form-group>
              </b-col>-->
               <!-- <b-col sm="4">
                <b-form-group label="Período - Data Início:" for="data_inicio">
                  <b-form-datepicker id="data_inicio" v-model="filtros.data_inicio" label-no-date-selected="Selecionar uma data" label-help="Use teclas de seta para navegar no calendário" />
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group label="Periodo - Data Término:" for="data_final">
                  <b-form-datepicker id="data_final" v-model="filtros.data_final" label-no-date-selected="Selecionar uma data" label-help="Use teclas de seta para navegar no calendário" />
                </b-form-group>
              </b-col>-->
           <!--   <b-col sm="4">
                <b-form-group label="Situação:">
                  <b-form-select v-model="filtros.situacao" class="mb-3">
                      <option selected :value="null"> Selecione </option>
                      <option v-for="situacao in situacoes" :value="situacao.value" :key="situacao.value"> {{ situacao.text }} </option>
                  </b-form-select>
                </b-form-group>
              </b-col>-->
            </b-row>
        </b-card-body>
        <b-row>
            <b-col sm="12">
                <b-container fluid>
                  <b-alert v-model="showMessage" variant="primary" dismissible v-html="mensagem">
                  </b-alert>
                  <span>
                    <table aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7" class="table table-responsive-sm table-bordered table-striped table-sm">
                      <thead>
                        <tr>
                          <th tabindex="0" scope="col" style="width: 1%">Atribuir Perfil</th>
                          <th tabindex="0" scope="col" style="width: 10%">Perfil Atribuído</th>
                          <th tabindex="0" scope="col" style="width: 10%">Data de Credenciamento</th>
                          <th tabindex="0" scope="col" style="width: 10%">Nome</th>
                          <th tabindex="0" scope="col" style="width: 15%">Perfil do Participante</th>
                          <th tabindex="0" scope="col" style="width: 10%">E-mail</th>
                          <th tabindex="0" scope="col" style="width: 5%">Ações</th>
                        </tr>
                      </thead>

                      <tbody v-if="participantes.data !== undefined">
                        <tr class="action" v-for="participante in participantes.data" :key="participante.id_user">
                          <td>
                            <label class="form-checkbox">
                              <div class="custom-control custom-checkbox custom-control-inline">
                                <input type="checkbox" class="custom-control-input" :id="'defaultInline1' + participante.id" :value="participante.id" v-model="selecionados" >
                                <label class="custom-control-label" :for="'defaultInline1' + participante.id"></label>
                              </div>
                            </label>
                          </td>
                          <td tabindex="0"> 
                            {{ participante.user_participante.user_perfil_conferencia.length > 0 ? 'Sim' : 'Não' }}  
                          </td>
                          <td tabindex="0">
                            {{ participante.updated_at }}
                          </td>
                          <td tabindex="0">
                            {{ participante.nome }}
                            </td>
                          <td tabindex="0"> 
                            {{ participante.user_participante.user_perfil_conferencia.length > 0 ? participante.user_participante.user_perfil_conferencia[0].perfil.nome : 'Não possuí' }}  
                          </td>
                          <td tabindex="0">
                            {{ participante.email }}
                          </td>
                          <td >
                            <b-button  tabindex="0" class="btn btn-sm btn-secondary action" title="Excluir" @click="excluirCredenciado(participante.id)">
                              <i class="fa fa-trash"></i>
                            </b-button>
                            <!--  <a v-if="can('participante.show')" class="btn btn-sm btn-secondary action" title="Visualizar" @click="visualizarParticipante(participante.id)">
                                  <i class="fa fa-search"></i>
                              </a>
                                <a  v-if="can('participante.update')" class="btn btn-sm btn-secondary action" title="Visualizar" @click="editarParticipante(participante.id)">
                                  <i class="fa fa-pencil"></i>
                              </a>
                                <a  v-if="can('participante.destroy')" class="btn btn-sm btn-secondary action" title="Visualizar" @click="excluirParticipante(participante.id)">
                                  <i class="fa fa-trash"></i>
                              </a>-->
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr class="action">
                          <td colspan="7" tabindex="0">Nenhum registro de credenciamento</td>
                        </tr>
                      </tbody>
                    </table>
                    <pagination tabindex="0" v-show="participantes.data !== undefined" :totalPorPagina="totalPorPagina" :resource="resource" :filtros="filtros"></pagination>
                  </span>
                </b-container>
            </b-col>
        </b-row>
        <b-card-footer class="p-12">
          <b-row>
            <b-col v-if="!loading" md="3">
              <b-button block variant="success"  @click="atribuirPerfil" :disabled="loading">
                <i class="fa fa-users"></i>&nbsp;&nbsp;<span>Atribuir Perfil</span>
              </b-button>
            </b-col>
            <b-col v-if="loading"  md="3">
              <b-button block variant="success" :disabled="true">
                <b-spinner small type="grow"></b-spinner>Salvando...
              </b-button>
            </b-col>
            <b-col md="3">
              <b-button block variant="primary"  @click="navigate('/participante')" :disabled="loading">
                <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>
        <b-modal size="lg" title="Atribuir Perfil" v-model="modalPerfil" :hide-footer="true">
          <b-card-body>
            <b-form>
              <b-row>
                <b-col cols="12">
                  <b-form-input type="text" :disabled="true" v-model="nome_conferencia" class="form-control"/>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="4">
                  <b-form-group label="Perfil:">
                    <b-form-select v-model="participantePerfil" :options="perfis"></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row v-for="participanteSelecionado in participantesSelecionados" :key="participanteSelecionado.user_id">
                <b-col cols="4">
                  <b-form-group label="Nome:">
                    <b-form-input type="text" :disabled="true" v-model="participanteSelecionado.nome" class="form-control"/>
                  </b-form-group>
                </b-col>
                <b-col cols="4">
                  <b-form-group label="CPF:">
                    <b-form-input type="text" :disabled="true" v-model="participanteSelecionado.cpf" class="form-control"/>
                  </b-form-group>
                </b-col>           
              </b-row>
          </b-form>
        </b-card-body>
        <b-card-footer class="p-12">
          <b-row>
            <b-col md="6">
            </b-col> 
            <b-col md="3">
              <b-button block variant="secondary" @click="fecharModalPerfil()">              
                <span>Cancelar</span>
              </b-button>
            </b-col>        
            <b-col md="3">
              <b-button block variant="primary" @click="confirmaAtribuirPerfil()">
                <span>Salvar</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>     
      </b-modal>
      </b-card>
    </span>
</template>

<script>
import Vue from 'vue'
import SessionStorage from '@/services/session-storage'
import Pagination from '@/components/shared/Pagination'
import {eventType} from '@/components/shared/eventType'
import {DatePicker, setupCalendar} from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'
import {required} from 'vuelidate/lib/validators'

setupCalendar({
  firstDayOfWeek: 2 // Monday
})

miniToastr.init()

export default {
  components: {
    Pagination,
    'v-date-picker': DatePicker,
    Multiselect
  },
  created () {
    if (!this.validaPerfil()) {
      this.$router.push('/')
    }
    this.carregarPerfis()
    this.$store.dispatch('getParticipacoes')
    this.mensagem = ''
    this.showMessage = false
  },
  data () {
    return {
      nome_conferencia: SessionStorage.get('conferencia_atual_nome'),
      totalPorPagina: 50,
      resource: 'participante/credenciado',
      modalCredenciar: false,
      modalCertificar: false,
      modalPerfil: false,
      loadingAtribuir: false,
      perfis: [],
      filtros: {
        uf: null,
        participacao: null,
        filter: '',
        situacao: null,
        data_inicio: null,
        data_final: null,
        gerado: null
      },
      form: {
        participantes_selecionados: []
      },
      options_gerado: [
        {'text': 'Sim', 'value': 1},
        {'text': 'Não', 'value': 0}
      ],
      participantesSelecionados: [],
      participantePerfil: null,
      selecionados: [],
      showMessage: false,
      mensagem: '',
      loading: false
    }
  },
  computed: {
    participantes () {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          return this.$store.state.pagination.getList
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    },
    participante () {
      return this.$store.state.participante.participante
    },
    participacoes () {
      return this.$store.state.participacao.participacoes
    },
    eventos () {
      return this.$store.state.evento.eventos
    },
    estados () {
      return this.$store.state.estado.listaEstados
    },
  },
  watch: {
    'filtros.filter': function () {
      this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
      this.setarFiltros(this.filtros)
    },
    'filtros.data_inicial': function () {
      this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
      this.setarFiltros(this.filtros)
    },
    'filtros.data_final': function () {
      this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
      this.setarFiltros(this.filtros)
    },
    'filtros.participacao': function () {
      this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
      this.setarFiltros(this.filtros)
    },
    'filtros.situacao': function () {
      this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
      this.setarFiltros(this.filtros)
    },
    'filtros.gerado': function () {
      this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
      this.setarFiltros(this.filtros)
    }
  },
  methods: {
    carregarPerfis () {
      Vue.http.post('api/perfil/index', {status: true}).then(response => {
        if (response.body.success) {
          let perfis = response.body.data

          for (let i = 0; i < perfis.length; i++) {
            this.perfis.push({value: perfis[i].id, text: perfis[i].nome})
          }
        }
      })
    },
    fecharModalPerfil () {
      this.modalPerfil = false 
    },
    confirmaAtribuirPerfil () { 
      if(!this.participantePerfil){
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error('Selecione um perfil!', 'Alerta', 5000)       
      }else{
          let participantesPerfil = []
          for(let i in this.participantesSelecionados) {
            let data = this.participantesSelecionados[i]
                participantesPerfil.push({
                  'user_id': data.user_id,
                  'nome': data.nome,
                  'cpf': data.cpf,
                  'perfil_id': this.participantePerfil})          
          }

          this.$bvModal.msgBoxConfirm('Tem certeza que deseja atribuir o perfil selecionado?', {
            okTitle: 'Confirmar',
            cancelTitle: 'Cancelar'
          }).then(valor => {
            if (valor) {
              this.loading = true
              Vue.http.post('api/participante/usuario/perfis/atribuir', participantesPerfil).then(response => {
                if (response.body.success) {
                  miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
                  miniToastr.success(response.body.msg, 'Sucesso!', 7000)
                  this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
                  this.modalPerfil = false 
                } else {
                  miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
                  miniToastr.error(response.body.msg, 'Alerta', 5000)
                }

                this.loading = false
              }).catch(e => {
                miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
                miniToastr.error(e.body.msg, 'Alerta', 5000)
                this.loading = false
              })
            }
          }).catch(erro => {})
        }
    },
    enviarSenha (id) {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja enviar a senha?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.loading = true
          Vue.http.post('api/participante/usuario/novasenha/' + id, {}).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            } else {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            }

            this.loading = false
          }).catch(e => {
            miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
            miniToastr.error(e.body.msg, 'Alerta', 5000)
            this.loading = false
          })
        }
      }).catch(erro => {})
    },
    gerarUser (id) {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.loading = true
          Vue.http.post('api/participante/usuario/' + id, {}).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            } else {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            }

            this.loading = false
          }).catch(e => {
            miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
            miniToastr.error(e.body.msg, 'Alerta', 5000)
            this.loading = false
          })
        }
      }).catch(erro => {})
    },
    excluirCredenciado (id) {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.loading = true
          let data = []
          data.push(id)

          Vue.http.put('api/participante/credenciado', {'participantes': data}).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            } else {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            }

            this.loading = false
          }).catch(e => {
            miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
            miniToastr.error(e.body.msg, 'Alerta', 5000)
            this.loading = false
          })
        }
      }).catch(erro => {})
    },
    atribuirPerfil () {      
      this.participantePerfil = null
      let credenciadosSelecionados = []
      for(let x in this.participantes.data) {
        let data = this.participantes.data[x]
        
        for(let i in this.selecionados) {
          // if(this.selecionados[i] == data.id && data.user_participante.user_perfil_conferencia.length === 0) {
          if(this.selecionados[i] == data.id) {
            credenciadosSelecionados.push({
              'user_id': data.user_participante.id,
              'nome': data.nome,
              'cpf': data.user_participante.cpf,
              'perfil_id': null})
          }
        }
      }

      if(credenciadosSelecionados.length == 0) {
        miniToastr.setIcon('danger', 'i', {'class': 'fa fa-check'})
        miniToastr.error('Selecione pelo menos um participante', 'Erro!', 7000)
        return false
      }

      this.modalPerfil = true
      this.participantesSelecionados = credenciadosSelecionados
    /*  this.mensagem = ''
      this.showMessage = false

      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.loading = true
          Vue.http.post('api/participante/credenciado/user', {'participantes': this.form.participantes_selecionados}).then(response => {
            this.loading = false
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})

              if (response.body.data.naoGerados !== '') {
                this.mensagem = 'Os seguintes dados já estão sendo utilizados por outro (s)credenciado(s): ' + response.body.data.naoGerados
                this.showMessage = true
              }
            } else {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            }
          }).catch(e => {
            this.loading = false
            console.log('Servidor está fora! ' + e)
          })
        }
      }).catch(erro => {})*/
    },
    validaPerfil () {
      let perfil = this.$store.state.perfil.perfil     
      if (perfil.is_admin_conferencia) {
        return true
      }
      return false
    },
    setarFiltros (filtros) {
      eventType.$emit('app', filtros)
    },
    visualizarParticipante (id) {
      this.$router.push('/participante/visualizar/' + id)
    },
    resetForm () {
      this.motivo = ''
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
    .multiselect.invalid .multiselect__tags,
    .multiselect.invalid .multiselect__tags span,
    .multiselect.invalid .multiselect__tags input {
        background:red;
    }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/participante/Credenciado.vue